import React from 'react';
import {useSelector} from 'react-redux';

import AppButton from '../../../components/Button/AppButton/AppButton';
import ConnectionTrackButton from '../../../components/Button/ConnectionTrackButton/ConnectionTrackButton';
import {ArticlePageLayout} from '../../../components/DataDisplay';
import {DisclaimerIcon} from '../../../components/Icons';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getTermsOfUseType} from '../../../consts/tnc/tncTypes';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import analyticsService from '../../../services/analyticsService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import tncService from '../../../services/tncService';
import {hideLoader, setNotificationInfo, showLoader} from '../../../state/ducks/global';
import {makeSelectAcceptedTncByType, makeSelectTncByType} from '../../../state/selectors/consumer';
import {dispatch} from '../../../state/store';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import TermsOfUseDescription from '../TermsOfUseDescription/TermsOfUseDescription';

const TermsOfUsePage = () => {
    const localizedStrings = getLocalizedStrings();
    const tncType = getTermsOfUseType();
    const termsOfUse = useSelector(makeSelectTncByType(tncType));
    const acceptedTermsOfUse = useSelector(makeSelectAcceptedTncByType(tncType));

    useDocumentTitle(localizedStrings[localizationKeys.TERMS_OF_USE_PAGE_TITLE]);

    if (!termsOfUse) return null;

    const {description, legals, updateDescription} = termsOfUse;

    if (!legals) return null;

    const onAcceptButtonClick = async () => {
        dispatch(showLoader());

        analyticsService.pushTNCTermsOfUseInteractionEvent(true);
        await tncService.setTnc(legals);

        dispatch(hideLoader());
    };

    const onDeclineButtonClick = () => {
        analyticsService.pushTNCTermsOfUseInteractionEvent(false);
        dispatch(
            setNotificationInfo(
                localizedStrings[localizationKeys.TERMS_OF_USE_DECLINED_ERROR],
                elementsTesIds.TNC_TOU_NOTIFICATION
            )
        );
    };

    const isUpdatedTnc = !!acceptedTermsOfUse;
    const summaryTitleKey = isUpdatedTnc
        ? localizationKeys.TERMS_OF_USE_TITLE_UPDATE
        : localizationKeys.TERMS_OF_USE_TITLE;
    const descriptionText = isUpdatedTnc ? updateDescription : description;

    return (
        <ArticlePageLayout
            icon={<DisclaimerIcon />}
            containerClassName='lg:pt-16'
            titleKey={summaryTitleKey}
            titleClassName={'mt-4'}
        >
            <TermsOfUseDescription className={'mt-4'} innerHtml={descriptionText} tncType={tncType} />
            <ConnectionTrackButton
                className='mt-20 lg:mt-16'
                button={AppButton}
                primary
                light
                onClick={onAcceptButtonClick}
                testId={elementsTesIds.TNC_TOU_BTN_AGREE}
            >
                {localizedStrings[localizationKeys.AGREE_BUTTON_TEXT]}
            </ConnectionTrackButton>
            <AppButton
                className='mt-4'
                secondary
                light
                onClick={onDeclineButtonClick}
                testId={elementsTesIds.TNC_TOU_BTN_DECLINE}
            >
                {localizedStrings[localizationKeys.DECLINE_BUTTON_TEXT]}
            </AppButton>
        </ArticlePageLayout>
    );
};

export default TermsOfUsePage;
